import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class EglenceVergiTuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EglenceVergiTuru";
    super(baseUrl);
  }


  getEglenceVergiTuruListe(yili?: number, butceGelirId?:number){
    
    return this.get("", { params: { yili: yili, butceGelirId: butceGelirId} });
   
  }

}
export default new EglenceVergiTuruAPI();
class EglenceVergiTuruListeRequest {
  public Yili?: number;
  butceGelirId?:number;
  constructor(yili?: number, butceGelirId?:number) {
    this.Yili = yili;
    this.butceGelirId=butceGelirId;
   
  }
}
export { EglenceVergiTuruListeRequest };